import React from "react";
import "./Chat.scss";

function Chat(){
    return(
        <div className="chat-box">
            chat ...
        </div>
    )
}

export default Chat
